import { React, useState, useEffect } from "react";
import BaseHome from "../../Home/BaseHome";
import { scrimGameCreate } from "../../../api/scrim.api";
import { routesFrontend } from "../../RouterFiles/routes";
import { toastError } from "../../../Utilities/toast";
import { Navigate, useLocation, useNavigate } from "react-router";
import { useProfileDataContext } from "../../ProfileContext/ProfileContext";
import { url } from "../../../config/url";
import { t } from "i18next";
import moment from "moment";

const PrivateScrimSummary = ({ data }) => {
  const { fetchAccountProfile } = useProfileDataContext();
  const location = useLocation();
  const updatedScrimData = location.state;
  const [navigateTo, setNavigateTo] = useState(null);
  const [CoinBalance, setCoinBalance] = useState([])
  const [currency, setCurrency] = useState(null)
  const [yourCurrency, setYourCurrency] = useState(null)
  const [isPremiumUser, setIsPremiumUser] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    var isPremium = localStorage?.getItem('premiumUser') || false
    setIsPremiumUser(isPremium == true || isPremium == "true" ? true : false)
  }, []);

  const rules = updatedScrimData?.rules || "";
  useEffect(() => {
    var currencyData = JSON.parse(localStorage.getItem("hostSettingCurrency"))
    setCurrency(currencyData);
    let wallet = JSON.parse(localStorage.getItem("profile"))?.wallet;
    for (let i = 0; i < wallet.length; i++) {
      if (wallet[i].currency === currencyData?._id) {
        setYourCurrency(wallet[i].winningAmount)
      }
    }

  }, [])
  const handlePayCoin = async () => {
    try {
      if (updatedScrimData) {
        updatedScrimData.entryFee = updatedScrimData?.feeAmount || 0;
        const response = await scrimGameCreate(updatedScrimData); // Call the API here

        if (response.success == true) {
          fetchAccountProfile()
          localStorage.setItem("toastMessage", response.data.msg);
          localStorage.removeItem("scrimDetails");
          localStorage.removeItem("selectedGameType")
          localStorage.removeItem("rules");
          navigate("/" + routesFrontend.privateScrim + '/' + routesFrontend.privateScrimList);
        } else {
          console.log("createscrimissue", response)
          toastError(response.data.errors[0].msg)
        }
      }
    } catch (error) {
      console.error("API call failed:", error);
    }
  };



  // useEffect(() => {
  //   const coin_balance = localStorage.getItem("profile");
  //   if (coin_balance) {
  //     const parsedBalance = JSON.parse(coin_balance);
  //     console.log(parsedBalance.wallet[1].winningAmount);
  //     setCoinBalance(parsedBalance?.wallet[1]?.winningAmount)
  //   }
  // }, []);



  //   const handlePayCoin = async () => {       // error message dont show code is ok
  //     try {
  //       if (updatedScrimData) {
  //         const response = await scrimGameCreate(updatedScrimData); // Call the API here
  //         if (response.success) {
  //           localStorage.removeItem("scrimDetails");
  //           setNavigateTo("/" + routesFrontend.privateScrim + '/' + routesFrontend.privateScrimList); // Set state for navigation
  //         } else {
  //           // If the response is not successful, show the error message in a toast
  //           const errorMessage = response.errors.length > 0 ? response.errors[0].msg : "An unknown error occurred.";
  //           toast.error(errorMessage);
  //         }
  //       }
  //     } catch (error) {
  //       console.error("API call failed:", error);
  //       toast.error("An unexpected error occurred. Please try again later.");
  //     }
  //   };

  // Add this in your return statement
  if (navigateTo) {
    return <Navigate to={navigateTo} />;
  }


  const isDataAvailable = data && data.length > 0;
  const formatTimeString = (isoString) => {
    const date = new Date(isoString);
    let hours = date.getUTCHours();
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const period = hours >= 12 ? 'PM' : 'AM';

    // Convert to 12-hour format
    hours = hours % 12 || 12; // Convert 0 hours to 12
    return `${String(hours).padStart(2, '0')}:${minutes} ${period}`;
  };

  const FormatTime = formatTimeString(updatedScrimData.time)
  return (
    <>
      <BaseHome title={t("private_contest.summary")}>
        <div className={`tournament-card-container `}>
          <div className="container tournament-card--wrap mt-3">
            {/* Render the tournament card if data is available */}
            <div className="tournament-card mb-4">
              <div className="card-body d-flex flex-column justify-content-between">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="card-title">
                         {updatedScrimData?.title.length > 30 ? (
                                        // scrolldelay="200" for delay marquee
                                        <marquee >
                                          {updatedScrimData?.title || "Contest"}
                                        </marquee>
                                      ) : (
                                        updatedScrimData?.title || "Contest"
                                      )}
                    {/* {updatedScrimData?.title || "Contest"} */}
                  </div>
                </div>
                <hr style={{ margin: "8px 0" }}></hr>
                <div className="row mt-3">
                  <div className="col-12">
                    <div className="tournament-card-detail">
                      {/* Tournament details */}
                      <div className="row">
                        <div className="col-3 tournament-card-box">
                          <div className="detail-item">
                            <div className="tournament-detail-value tournament-detail-value-1">
                              {/* {new Date(
                                updatedScrimData?.date
                              ).toLocaleDateString()} */}
                              {moment(updatedScrimData?.date).format("DD/MM/YYYY")}
                            </div>
                            <div className="tournament-detail-label tournament-detail-label-1 letter-spacing">Date</div>

                          </div>
                        </div>
                        <div className="col-3 tournament-card-box">
                          <div className="detail-item">
                            <div className="tournament-detail-value tournament-detail-value-1">
                            {moment(updatedScrimData.time).format("hh:mm A")}
                            </div>
                            <div className="tournament-detail-label tournament-detail-label-1">Time</div>

                          </div>
                        </div>
                        {(updatedScrimData?.selectedFieldFromGameTitles?.[0]?.selectedTitle?.value &&
                          updatedScrimData?.selectedFieldFromGameTitles?.[0]?.selectedTitleValue?.value)
                          &&
                          <div className="col-3 tournament-card-box">
                            <div className="detail-item">
                              <div className="tournament-detail-value tournament-detail-value-1">
                                {updatedScrimData?.selectedFieldFromGameTitles?.[0]?.selectedTitleValue?.value || "Unknown"}
                              </div>
                              <div className="tournament-detail-label tournament-detail-label-1">{updatedScrimData?.selectedFieldFromGameTitles?.[0]?.selectedTitle?.value}</div>

                            </div>
                          </div>
                        }
                        {(updatedScrimData?.selectedFieldFromGameTitles?.[1]?.selectedTitle?.value &&
                          updatedScrimData?.selectedFieldFromGameTitles?.[1]?.selectedTitleValue?.value)
                          &&
                          <div className="col-3 tournament-card-box">
                            <div className="detail-item">
                              <div className="tournament-detail-value tournament-detail-value-1">
                                {updatedScrimData?.selectedFieldFromGameTitles?.[1]?.selectedTitleValue?.value || "Unknown"}
                              </div>
                              <div className="tournament-detail-label tournament-detail-label-1">{updatedScrimData?.selectedFieldFromGameTitles?.[1]?.selectedTitle?.value}</div>

                            </div>
                          </div>
                        }
                       
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-3">
                  <div className="tournament-details-winnings tournament-details-winnings-1">
                    <div
                      className="d-flex justify-content-flex-start"
                      style={{ gap: 20 }}
                    >
                      <p className="join-info">
                        Players:{" "}
                        <span className="tournament-prizepool">
                          {updatedScrimData?.noOfPlayerCapacity}
                        </span>
                      </p>
                      <p className="prize-info">
                        Winners:{" "}
                        <span className="tournament-prizepool">
                          {updatedScrimData?.noOfWinner}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="private-scrim-game-h1">{t("private_contest.game_rules")}</div>
          <div className="private-scrim-game-rules">
            <div
              className="rules-list private-contest-max-height"
              dangerouslySetInnerHTML={{ __html: rules }}
            />
          </div>
          <div className="private-scrim-coins-details " style={{ marginBottom: "8rem" }}>
            <div className="private-scrim-coins-details-flex">
              <div className="private-scrim-coins-details-label text-lowercase">
                {t("private-scrims.balance", { currency: currency?.name })}
              </div>
              <div className="private-scrim-coins-details-label">
              {yourCurrency}
                {" "}
                <span>
                  <img className="coinbalance-img" src={`${url.IMAGE_URL}${currency?.img}`} alt="coin" />
                </span>{" "}
                
              </div>
            </div>
            <div className="private-contest-sepration-line"></div>
            <div className="private-scrim-coins-details-flex">
              <div className="private-scrim-coins-details-label text-lowercase">{t("private_contest.your_fee")}</div>
              {isPremiumUser ? 
                <div className="private-scrim-coins-details-label">
                  {" "}free
                </div>
                :
                <div className="private-scrim-coins-details-label">
                  {updatedScrimData?.feeAmount}
                  {" "}
                  <span>
                    <img className="coinbalance-img" src={`${url.IMAGE_URL}${currency?.img}`} alt="coin" />
                  </span>{" "}
                  
                </div>
              }
            </div>
            { isPremiumUser && (
                <>
                  <div className="private-contest-sepration-line"></div>
                  <div className="mb-4 mt-4">
                    <div class="ps_coin_saved">
                      <span className="tournament-joining-popup-entryfee-text text-lowercase">
                        {currency?.name} saved {updatedScrimData?.feeAmount} <img className="tournament-joining-popup-entryfee-img" style={{marginTop: "0.1rem"}} src={`${url.IMAGE_URL}${currency?.img}`} /> 
                      </span>
                    </div>
                  </div>
                </>
              )}
          </div>
        </div>
        <div className="btn-flex-private-scrim">
        { isPremiumUser ? (
            <button
              className="submit-button-withimg-icon"
              onClick={handlePayCoin}
            >
              submit
            </button>
          )
          :
          (
            <button
              className="submit-button-withimg-icon"
              onClick={handlePayCoin}
            >
              Pay
              {" "}
              {updatedScrimData?.feeAmount}
              <span>
                <img className="coinbalance-img-btn" src={`${url.IMAGE_URL}${currency?.img}`} alt="gems" />
              </span>{" "}
              
            </button>
          )}
        </div>
      </BaseHome>
    </>
  );
};

export default PrivateScrimSummary;
